// tabs/ExpediteTab.jsx - Expedite tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, Button, Paper } from '@mantine/core';

const ExpediteTab = ({ selectedLineId }) => {
  const [expediteData, setExpediteData] = useState({
    recommendedVendor: {
      docNo: '',
      type: '',
      vendor: ''
    },
    convertedFrom: {
      no: '',
      docType: ''
    }
  });

  const handleRecommendedVendorChange = (field, value) => {
    setExpediteData(prev => ({
      ...prev,
      recommendedVendor: { ...prev.recommendedVendor, [field]: value }
    }));
  };

  const handleConvertedFromChange = (field, value) => {
    setExpediteData(prev => ({
      ...prev,
      convertedFrom: { ...prev.convertedFrom, [field]: value }
    }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        {/* Left Column - Recommended Vendor */}
        <Grid.Col span={6}>
          <Paper withBorder p="sm">
            <Text size="sm" fw={500} mb="sm">Recommended Vendor</Text>
            <Stack spacing="xs">
              <Group spacing="xs" align="flex-end">
                <Button variant="default" size="xs" style={{ padding: '0 8px' }}>
                  📄
                </Button>
                <Text size="sm" fw={500} w={60}>Doc No:</Text>
                <TextInput
                  value={expediteData.recommendedVendor.docNo}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  onChange={(e) => handleRecommendedVendorChange('docNo', e.target.value)}
                />
                <Text size="sm" fw={500} w={40}>Type:</Text>
                <TextInput
                  value={expediteData.recommendedVendor.type}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  onChange={(e) => handleRecommendedVendorChange('type', e.target.value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Button variant="default" size="xs" style={{ padding: '0 8px' }}>
                  📄
                </Button>
                <Text size="sm" fw={500} w={60}>Vendor:</Text>
                <TextInput
                  value={expediteData.recommendedVendor.vendor}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  onChange={(e) => handleRecommendedVendorChange('vendor', e.target.value)}
                />
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Right Column - Converted From */}
        <Grid.Col span={6}>
          <Paper withBorder p="sm">
            <Text size="sm" fw={500} mb="sm">Converted From</Text>
            <Stack spacing="xs">
              <Group spacing="xs" align="flex-end">
                <Button variant="default" size="xs" style={{ padding: '0 8px' }}>
                  📄
                </Button>
                <Text size="sm" fw={500} w={40}>No.:</Text>
                <TextInput
                  value={expediteData.convertedFrom.no}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  onChange={(e) => handleConvertedFromChange('no', e.target.value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={80}>Doc Type:</Text>
                <TextInput
                  value={expediteData.convertedFrom.docType}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  onChange={(e) => handleConvertedFromChange('docType', e.target.value)}
                />
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Bottom Row - Action Buttons */}
        <Grid.Col span={12}>
          <Group spacing="md" mt="md">
            <Group spacing="xs">
              <Button variant="default" size="xs" style={{ padding: '0 8px' }}>
                📄
              </Button>
              <Button variant="default" size="sm">
                W/H Allocation
              </Button>
            </Group>

            <Button variant="default" size="sm" leftSection="📋">
              Serials
            </Button>

            <Button variant="default" size="sm" leftSection="✉️">
              X-Ref Message
            </Button>

            <Button variant="default" size="xs" style={{ padding: '0 8px' }}>
              🖨️
            </Button>

            <Button variant="default" size="sm" leftSection="✉️">
              Message
            </Button>

            <Button variant="default" size="sm" leftSection="📄">
              Memo
            </Button>
          </Group>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default ExpediteTab;
